<template>
  <label class="app-data-filter-checkbox-group-child-item">
    <input v-model="model" type="checkbox" :value="valueAsScalar" />
    <span class="item-title">{{ item.title }}</span>
  </label>
</template>

<script>
import { getItemValueAsScalar } from '@/helpers/data-filter/utils';

export default {
  name: 'AppDataFilterCheckboxGroupChildItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    valueAsScalar() {
      return getItemValueAsScalar(this.item);
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-data-filter-checkbox-group-child-item {
  margin-bottom: 0;
  padding: 8px 16px;
  border: 1px solid vars.$c-gray-da;
  transition: border 0.2s ease-in-out;

  input[type='checkbox'] {
    display: none;
  }

  &:has(input[type='checkbox']:checked) {
    border-color: vars.$c-dark-gray;
  }
}
</style>
